import Navbar from "../../NavBar/Navbar"
import SideBar from "../../NavBar/Sidebar"
import IndicadoresContent from "./IndicadoresContent"


interface ChildsProps {
    logout: () => void
}


const Indicadores: React.FC<ChildsProps> = ({logout}) => {

    return (
        <>
            <div className="sidebar-noneoverflow">
                <Navbar logout={logout} />

                <div className="main-container" id="container">
                    <SideBar />
                    <IndicadoresContent />
                </div>

            </div>

        </>
    )



}



export default Indicadores